import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment'
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: Socket;
  private registerSocketStatusSubject = new BehaviorSubject<any>(null);
  registeredUserSocketStatus$ = this.registerSocketStatusSubject.asObservable();

  private connectionSocketStatusSubject = new BehaviorSubject<any>(null);
  connectionSocketStatus$ = this.connectionSocketStatusSubject.asObservable();

  private onlineUsersSubject = new BehaviorSubject<string[]>([]);
onlineUsers$ = this.onlineUsersSubject.asObservable();
  // private readonly SERVER_URL = 'https://dev.whiterobe.in:3006'; // ✅ Socket server endpoint

  constructor() {
    // this.socket = io(this.SERVER_URL, {
    //   transports: ['websocket', 'polling'],
    //   secure: true,                   // ✅ Optional: ensures HTTPS
    //   withCredentials: false          // ✅ If your server doesn't need cookies
    // });

    // Using same domain, no port
// this.socket = io('https://dev.whiterobe.in', {
//   path: '/socket.dev', // default
//   transports: ['websocket', 'polling'],
// });
// this.socket = io('https://dev.whiterobe.in', {
//     path: '/socket.dev', // default
//   transports: ['websocket'],
//   secure: true
// });

// this.socket = io('https://dev.whiterobe.in', {
//   path: '/socket.dev/socket.io',
//   transports: ['websocket', 'polling'],
// });
this.socket = io(environment.SOCKET_API, {
  path: environment.SOCKET_PATH,
  transports: ['websocket', 'polling'],
});

// When connected
this.socket.on('connect', () => {
  this.connectionSocketStatusSubject.next({
    status: 'connected',
    id: this.socket.id
  });
});

// When disconnected
this.socket.on('disconnect', (reason) => {
  this.connectionSocketStatusSubject.next({
    status: 'disconnected',
    reason: reason
  });
});

// Optional: reconnect attempt
this.socket.on('reconnect_attempt', () => {
  this.connectionSocketStatusSubject.next({
    status: 'reconnecting'
  });
});

this.socket.on("online-users", (users: string[]) => {
  this.onlineUsersSubject.next(users);
});


  }
  register(userId: string) {
    this.socket.emit('register', userId);
  }

  // sendMessage(message: string, name:string) {
  //   // const payload = {
  //   //   sender: name,  // Set this on login or input
  //   //   message: message,
  //   // };

  //   // this.socket.emit('send_message', payload);
  //   this.socket.emit('private_message', {
  //     toUserId: name,
  //     message: message
  //   });
  // }

  sendMessage(to: string, from: string, message: string) {
    console.log("sending chat msg", { to, from, message })
    this.socket.emit('private_message', { to, from, message });
  }

  // onMessage(): Observable<any> {
  //   return new Observable((observer) => {
  //     // this.socket.on('receive_message', (data) => {
  //     //   observer.next(data);
  //     // });
  //     this.socket.on('private_message', (data) => {
  //       observer.next(data);
  //     });
  //   });
  // }
  registerUser(userId: string) {
    this.socket.emit('register', userId);

    this.socket.on("register-success", (data) => {
      console.log("Success:", data);
      this.registerSocketStatusSubject.next({ success: true, data });
    });
    
    this.socket.on("register-failed", (data) => {
      console.log("Failed:", data);
      this.registerSocketStatusSubject.next({ success: false, data });
    });
  }
  onMessage(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('private_message', data => observer.next(data));
    });
  }

  sendPrivateMessage(from: string, to: string, message: string) {
    this.socket.emit('private_message', { from, to, message });
  }

  onPrivateMessage(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('private_message', (data) => {
        console.log('Private message received on client:', data); // ✅ You must see this
        observer.next(data);
      });
    });
  }
  disconnect() {
    // this.socket.removeAllListeners();
    this.socket.disconnect();
  }
  reconnect(userId: string) {
    if (!this.socket.connected) {
      this.socket.connect();
      // registerUser(123);
      this.socket.emit('register', userId);
    }
  }
  
}
